import { type Chain, bsc, bscTestnet, mainnet, opBNB, opBNBTestnet, sepolia, mantle } from 'wagmi/chains';
import { defineChain } from 'viem';
import localConfig from 'config';

export const phron_testnet =  defineChain({
  id: 4477,
  name: "phron testnet",
  network: 'PHRON_TESTNET',
  nativeCurrency: {
    decimals: 18,
    name: 'Phron Token',
    symbol: 'PHR',
  },
  rpcUrls: {
    default: { http: ['https://testnet.phron.ai'] },
    public: { http: ['https://testnet.phron.ai'] },
  },
  blockExplorers: {
    etherscan: { name: 'phronscan', url: 'https://testnet.phronscan.io/' },
    default: { name: 'phronscan', url: 'https://testnet.phronscan.io/' },
  },
  testnet: true,
})

const getSupportedChains = (): Chain[] => {
  if (localConfig.isOnTestnet) {
    return [phron_testnet];
  }

 // return [bsc, mainnet, opBNB];
 return [mantle]
};

export const governanceChain = localConfig.isOnTestnet ? bscTestnet : bsc;

export const chains = getSupportedChains();

export const defaultChain = chains[0];
